import { useMemo } from "react";
import bondSecuritiesStore from "@/store/bondSecuritiesStore";
import { findBondSecurityByIsin } from "@/store/bondSecuritiesStoreACTIONS";
import tradeFromScratchStore, {
  IBondOptionTicket,
  returnEmptyBondOptionTicket,
} from "@/store/tradeFromScratchStore";
import {
  BOND_OPTION_TICKET_REQUIRED_KEYS,
  returnBondOptionDateIssue,
  returnMissingBondOptionTicketEntries,
} from "../helper/bondOptionTicketHelper";

// One bond option ticket by id: the stored ticket, its updater and what derives from it.
export function useBondOptionTicket(ticketId: string) {
  const storedTicket = tradeFromScratchStore(
    (state) => state.bondOptionTicketsByTicketId[ticketId],
  );
  const updateTicket = tradeFromScratchStore(
    (state) => state.updateBondOptionTicket,
  );
  // Subscribed so the ticket re-renders if the securities land after it mounts.
  bondSecuritiesStore((state) => state.bondSecurities);

  const emptyTicket = useMemo(() => returnEmptyBondOptionTicket(), []);
  const ticket = storedTicket ?? emptyTicket;
  const underlying = findBondSecurityByIsin(ticket.isin);

  return {
    ticket,
    updateBondOptionTicket: (changes: Partial<IBondOptionTicket>) =>
      updateTicket(ticketId, changes),
    underlying,
    missingEntries: returnMissingBondOptionTicketEntries(ticket),
    dateIssue: returnBondOptionDateIssue(ticket, underlying),
    requiredKeys: BOND_OPTION_TICKET_REQUIRED_KEYS,
  };
}
